import { EnvironmentConfig } from "./env.types";


export const environment: EnvironmentConfig = {
  name: 'development',
  apiUrl: 'https://api.dev-clearsky.terabase.tech/api/v1',
  authConfig: {
    region: 'us-west-2',
    clientId: '409jlg5csi4fec64tn97e18d97',
    identityPoolId: '879e0dc5-8663-43ae-a1fd-00787a704edd',
    responseType: 'code',
    userPool: 'us-west-2_36Ud7LfLL',
    signOutRedirect: 'https://www.dev-clearsky.terabase.services/'
  },
  bucketName: 'terabase-dev-image-proc',
  authDomain: 'terabase-dev.auth.us-west-2.amazoncognito.com',
  cookieDomain: 'terabase.services',
  terabaseCompanyId: '61f961c95cdd4e0c4d2b4ec4'
};
